<template>
    <div class="app-container">
        <el-alert title="注:以下所填数据在故障提交review之前都可以修改" type="info" style="margin-bottom: 10px"/>
        <el-row>
            <el-col :span="12">
                <el-form ref="form" :model="form" :rules="rules" label-width="120px" size="mini">
                    <el-form-item label="故障简述" prop="title">
                        <el-input v-model="form.title" placeholder="请填写故障的简洁描述"/>
                    </el-form-item>
                    <el-form-item label="故障级别">
                        <el-select
                            v-model="form.level"
                            style="display: block"
                            placeholder="请选择故障级别"
                        >
                            <el-option
                                v-for="item in level_list"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="业务线" prop="category_1">
                        <el-select v-model="form.category_1" @change="reloadCategory2">
                            <el-option
                                v-for="item in category1_list"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                        <el-button type="primary" icon="el-icon-plus" @click="handleCategory1"/>
                    </el-form-item>
                    <el-form-item label="项目名称" prop="category">
                        <el-select v-model="form.category" placeholder="请先选择业务线">
                            <el-option
                                v-for="item in category2_list"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                        <el-button type="primary" icon="el-icon-plus" @click="handleCategory2"/>
                    </el-form-item>
                    <el-form-item label="发现方式">
                        <el-select v-model="form.discovery" style="display: block">
                            <el-option
                                v-for="item in discovery_list"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="故障详情">
                        <el-input
                            v-model="form.detail"
                            :autosize="{ minRows: 6, maxRows: 6}"
                            type="textarea"
                            placeholder="例:QQ音乐访问量、考拉Fm访问异常，导致项目整体服务访问量降低，影响车机端部分功能，网关大量500告警"
                        />
                    </el-form-item>
                    <el-form-item label="开始时间" prop="start_time">
                        <el-date-picker
                            v-model="form.start_time"
                            type="datetime"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="请填写故障的产生时间"
                            style="width: 100%;"
                        />
                    </el-form-item>
                    <el-form-item label="相关人员" prop="users">
                        <el-select
                            v-model="form.users"
                            :remote-method="remoteMethod"
                            :loading="loading"
                            multiple
                            filterable
                            remote
                            style="display: block"
                            placeholder="请输入名称进行搜索"
                        >
                            <el-option
                                v-for="item in options4"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            />
                        </el-select>
                    </el-form-item>
                    <el-form-item label="影响SLA">
                        <el-switch
                            v-model="form.sla"
                            active-text="是"
                            inactive-text="否"
                            active-value="1"
                            inactive-value="0"
                        />
                    </el-form-item>
                    <el-form-item>
                        <el-button type="success" @click="onSubmit('form')">保存</el-button>
                        <el-button @click="onCancel">取消</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
        </el-row>
        <el-dialog :visible.sync="dialogCategory1Visible" title="新增业务线">
            <el-form
                ref="category_1_form"
                :model="category_form"
                :rules="category_rules"
                label-width="120px"
            >
                <el-form-item label="业务线名称" prop="name">
                    <el-input v-model="category_form.name"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCategory1Visible = false">取 消</el-button>
                <el-button type="primary" @click="createCategory1">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog :visible.sync="dialogCategory2Visible" title="新增项目">
            <el-form
                ref="category_2_form"
                :model="category_form"
                :rules="category_rules"
                label-width="120px"
            >
                <el-form-item label="业务线" prop="parent_id">
                    <el-select v-model="category_form.parent_id" style="display: block">
                        <el-option
                            v-for="item in category1_list"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                        />
                    </el-select>
                </el-form-item>
                <el-form-item label="项目名称" prop="name">
                    <el-input v-model="category_form.name"/>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogCategory2Visible = false">取 消</el-button>
                <el-button type="primary" @click="createCategory2">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import {
  addEvent,
  filterUser,
  levelList,
  discoveryList,
  categoryList,
  categoryChildren,
  addCategory
} from "../../../services/fault/new";
export default {
  data() {
    const checkUsers = (rule, value, callback) => {
      if (value.length < 2) {
        return callback(new Error("请选择至少2个相关人员"));
      } else {
        callback();
      }
    };
    return {
      level_list: [],
      discovery_list: [],
      category1_list: [],
      category2_list: [],
      options4: [],
      list: [],
      loading: false,
      form: {
        title: "",
        level: "P1",
        category_1: "",
        category: "",
        discovery: "1",
        detail: "",
        start_time: "",
        users: [],
        sla: "0",
        current_user: ""
      },
      dialogCategory1Visible: false,
      dialogCategory2Visible: false,
      category_form: {
        name: "",
        parent_id: "",
        current_user: ""
      },
      rules: {
        title: [
          { required: true, message: "请输入故障简述", trigger: "blur" },
          { min: 1, max: 50, message: "最多50个字符", trigger: "blur" }
        ],
        category_1: [
          { required: true, message: "请选择业务线", trigger: "change" }
        ],
        category: [
          { required: true, message: "请选择项目", trigger: "change" }
        ],
        start_time: [
          { required: true, message: "请选择开始时间", trigger: "change" }
        ],
        users: [{ required: true, validator: checkUsers, trigger: "change" }]
      },
      category_rules: {
        name: [{ required: true, message: "请输入名称", trigger: "blur" }],
        parent_id: [
          { required: true, message: "请选择业务线", trigger: "change" }
        ]
      }
    };
  },
  mounted() {
    levelList().then(response => {
      this.level_list = response.level_data.map(item => {
        return {
          value: item.name,
          label: item.name + "(" + item.info.name + ")"
        };
      });
    });
    discoveryList().then(response => {
      this.discovery_list = response.discovery_data.map(item => {
        return { value: item.id, label: item.name };
      });
    });
    categoryList({ level: 1 }).then(response => {
      this.category1_list = response.category_data.map(item => {
        return { value: item.id, label: item.name };
      });
    });
  },
  methods: {
    reloadCategory2() {
      this.form.category = "";
      categoryChildren({ category_id: this.form.category_1 }).then(response => {
        this.category2_list = response.category_data.map(item => {
          return { value: item.id, label: item.name };
        });
      });
    },
    onSubmit(formName) {
      this.form.current_user = this.$cookies.get('user_name');
      const loading = this.$loading({
          lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      this.$refs[formName].validate(valid => {
        if (valid) {
          addEvent(this.form).then(response => {
              this.$router.push({ path: "/fault/fault_table" });
              this.$message({
                message: '添加成功',
                type: "success"
              });
             loading.close();
          }, err => {
            this.$message.error(err.message);
            loading.close();
          });
        } else {
          loading.close();
          return false;
        }
      });
    },
    onCancel() {
      this.$router.push({ path: "/fault/fault_table" });
    },
    remoteMethod(query) {
      if (query !== "") {
        this.loading = true;
        filterUser(query).then(response => {
          this.list = Object.keys(response.user_data).map(item => {
            return {
              value: item,
              label: response.user_data[item].name + "(" + item + ")"
            };
          });
        });
        setTimeout(() => {
          this.loading = false;
          this.options4 = this.list;
        }, 200);
      } else {
        this.options4 = [];
      }
    },
    handleCategory1() {
      this.dialogCategory1Visible = true;
      this.category_form.parent_id = "";
      this.category_form.name = "";
      this.category_form.current_user = this.name;
    },
    handleCategory2() {
      this.dialogCategory2Visible = true;
      this.category_form.parent_id = this.category_form.parent_id
        ? this.category_form.parent_id
        : this.form.category_1;
      this.category_form.name = "";
      this.category_form.current_user = this.name;
    },
    createCategory1() {
      this.$refs.category_1_form.validate(valid => {
        if (valid) {
          addCategory(this.category_form).then(response => {
              this.dialogCategory1Visible = false;
              categoryList({ level: 1 }).then(response => {
                this.category1_list = response.category_data.map(item => {
                  return { value: item.id, label: item.name };
                });
              });
          }, err => {
              this.$message({ type: 'error', message: err.message })
          });
        } else {
          return false;
        }
      });
    },
    createCategory2() {
      this.$refs.category_2_form.validate(valid => {
        if (valid) {
          addCategory(this.category_form).then(response => {
              this.dialogCategory2Visible = false;
              categoryChildren({ category_id: this.form.category_1 }).then(
                response => {
                  this.category2_list = response.category_data.map(
                    item => {
                      return { value: item.id, label: item.name };
                    }
                  );
                }
              );
          }, err => {
              this.$message({ type: 'error', message: err.message })
          });
        } else {
          return false;
        }
      });
    }
  }
};
</script>
